import React from "react";
import {
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  
const logo = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/logo/VIZAURA-LOGO-TM-2.png"
  return (
    <div>
      {/* <div className="bg-blue-300 p-6 flex flex-col md:flex-row justify-between items-center mt-10">
        <h1 className="text-3xl md:text-2xl font-bold text-[#A52A2A] text-center md:w-[70%] font-sans">
          Please get in touch to find out
          <br /> more about our services
        </h1>
        <button
          type="button"
          className="bg-green-600 text-white w-[130px] h-[35px] mt-6 rounded-xl px-3"
        >
          CONTACT US
        </button>
      </div> */}

      <div className="flex flex-col md:flex-row bg-black p-6 md:p-10 justify-around w-full">
        <div className="mt-7 w-full md:w-[300px] text-white">
          <div className="flex gap-1 text-white text-xl font-bold">

            <h1 className=" font-serif">
              <Link to="/" className="mr-auto">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-12 w-auto transition-transform duration-300 hover:scale-105"
                />
              </Link>
            </h1>
          </div>
          <p className="mt-5 text-white text-sm">
            One Wall  Endless Vibes
          </p>

          <div className="mt-5">


          </div>
        </div>

        <div className="mt-7 w-full md:w-[300px] text-white">
          <h3 className="font-bold text-lg p-2">Quick Links</h3>
          <a
            href="https://www.instagram.com/studio.vizaura?igsh=MXFpOGNqdXVuY3Ixdw=="
            target="_blank"
            rel="noopener noreferrer"
            className="flex pt-5 flex-row gap-2"
          >
            <span
              className="pt-1"
              style={{
                background: 'radial-gradient(circle at 30% 30%, #f09433)', // Instagram color gradient
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block'
              }}
            >
              <FaInstagram size={20} />
            </span> <span
              className="hover:underline font-bold"
              style={{
                background: 'radial-gradient(circle at 30% 30%, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Instagram
            </span>
          </a>
          <Link
            to="/artshows"
            className="flex pt-4 flex-row gap-2 text-white hover:text-yellow-500 transition-colors font-medium text-sm"
          >
            <span>🎨</span>
            <span className="hover:underline">Art Shows & Exhibitions</span>
          </Link>
          <a
            href="https://www.instagram.com/studio.vizaura"
            target="_blank"
            rel="noopener noreferrer"
            className="flex pt-4 flex-row gap-2"
          >
            {/* <a
              className="pt-1"
              style={{
                background: 'radial-gradient(circle at 30% 30%)', // Facebook color gradient
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block'
              }}
            >
              <FaFacebookF size={20} />
            </a> 
            <a
              className="hover:underline font-bold"
              style={{
                background: 'radial-gradient(circle at 30% 30%, #1877F2, #0062E0, #0041C2)', // Facebook blue gradient
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Facebook
            </a> */}
          </a>
          {/* <a
            href="https://www.instagram.com/art_fluence_?igsh=aXc2dDNvaTlhM2pi"
            target="_blank"
            rel="noopener noreferrer"
            className="flex pt-4 flex-row gap-2"
          >
            <a
      className="pt-1"
      style={{
        background: 'radial-gradient(circle at 30% 30%)', // Twitter blue gradient
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        display: 'inline-block'
      }}
    >
      <FaTwitter size={20} />
    </a> <a
              className="hover:underline font-bold"
              style={{
                background: 'radial-gradient(circle at 30% 30%, #1DA1F2, #0D8BDE, #0A74B9)', // Twitter blue gradient
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Twitter
            </a>
          </a> */}
        </div>

        <div className="mt-7 w-full md:w-[300px] text-white">
          <h3 className="font-bold text-lg p-2">Get in Touch</h3>
          <p className="flex gap-3 text-sm mt-2 pt-4">
            {/* Call Functionality */}
            <FaPhone className="mt-1" size={15} />
            <a href="tel:+919016663115" className="hover:underline font-semibold">
              +91 9016663115
            </a>
          </p>

          <p className="flex gap-3 text-sm mt-2 pt-3">
            {/* Mailto Functionality */}
            <FaEnvelope className="mt-1" size={15} />
            <a
              href="mailto:info.vizaura@gmail.com?subject=Inquiry from Website&body=Hello, I would like to inquire about your services."
              className="hover:underline font-semibold"
            >
              info.vizaura@gmail.com
            </a>
          </p>
          <p className="flex gap-3 text-sm mt-2 pt-3">
            <FaMapMarkerAlt className="mt-1" size={15} />
            <a
              href="https://www.google.com/maps/place/23%C2%B000'12.3%22N+72%C2%B033'18.8%22E/@23.0034198,72.5526496,17z/data=!3m1!4b1!4m4!3m3!8m2!3d23.0034198!4d72.5552245?hl=en&entry=ttu&g_ep=EgoyMDI0MDkzMC4wIKXMDSoASAFQAw%3D%3D"
              className="hover:underline font-semibold text-gray-400"
            >
              Paldi, bhattha, Ahmedabad 380007
            </a>
          </p>
        </div>

      </div> <div className="bg-black">
        {/* <h1>My App</h1> */}
        {/* <ContactForm /> */}
      </div>

      <div className="w-full bg-black text-sm text-gray-400 p-4">
        <hr className="bg-white" />
        <div className="flex flex-col items-center pt-5 space-y-2">
          <p className="p-2 text-center">
            CopyRight @<span className="text-white">Vizaura</span>2024
          </p>

          <p className="p-2">
            Powered by{' '}
            <a href="https://www.infinitech.co.in/" className="underline text-white">
              Infinitech
            </a>
          </p>
        </div>
      </div>



    </div>
  );
};

export default Footer;
